export default __webpack_public_path__ + "static/media/flags.f836dbe0.svg";